export default function GetYearList(min, max, isEvenNumber = false) {
    let yearList = [];
    for (var i = min; i <= max; (isEvenNumber ? i += 2 : i++)) {
        yearList.push({ value: `${i}`, label: `${i} ${i > 1 ? 'years' : 'year'} ` })
    }
    // Check if isEvenNumber is true and 8 year exists in the array
    if (isEvenNumber && yearList.some(item => item.value === "8")) {
        yearList = yearList.filter(item => item.value !== "8"); // Remove 8
        yearList.push(
            { value: "84", label: "8 years - Joint Policy / 4 years - Individual Policies" },
            { value: "86", label: "8 years - Joint Policy / 6 years - Individual Policies" }
        );
    }
    return yearList;
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/YearList.js